/* eslint-disable react-hooks/exhaustive-deps */
import { memo } from 'react';

export const UserLog = memo(() => {
  return <p>ログインユーザーのログ</p>;
});
